(function () {
  // Function to update the custom price element
  function updateBtnAtcPrice() {
    var priceElement = document.querySelector(".price-item--regular");
    var btnAtcPrice = document.querySelector(".btnAtcPrice");

    if (priceElement && btnAtcPrice) {
      var newPrice = priceElement.textContent.trim();
      btnAtcPrice.textContent = newPrice;
    }
  }

  // Debounce helper: waits for a pause before running the function
  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  // Debounced version of the price update function (e.g., 300ms delay)
  var debouncedUpdatePrice = debounce(updateBtnAtcPrice, 300);

  // Initial update on page load
  updateBtnAtcPrice();

  // Function to monitor URL changes
  function observeUrlChange(callback) {
    let lastUrl = location.href;

    // Patch pushState and replaceState
    ["pushState", "replaceState"].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        original.apply(this, arguments);
        var event = new Event("urlChange");
        window.dispatchEvent(event);
      };
    });

    // Listen for popstate (browser back/forward)
    window.addEventListener("popstate", function () {
      var event = new Event("urlChange");
      window.dispatchEvent(event);
    });

    // Custom listener for urlChange
    window.addEventListener("urlChange", function () {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        callback();
      }
    });
  }

  // Start observing URL changes
  observeUrlChange(debouncedUpdatePrice);

  // Also observe price DOM changes (Shopify swaps the price HTML)
  var priceContainer = document.querySelector(".price__regular");
  if (priceContainer) {
    new MutationObserver(debouncedUpdatePrice).observe(priceContainer, {
      childList: true,
      subtree: true,
    });
  }
})();
